// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BxSe","col":"styles_col__1Lsgs"};